module.exports = __webpack_public_path__ + "static/media/inventory-reports-performance.ed82ff7a.png";